module.exports = __webpack_public_path__ + "media/images/client/favicons/apple-touch-icon-114x114-97664446922f1da0f10e8dc6fa8418ea.png";